// extracted by mini-css-extract-plugin
module.exports = {"container":"Titles__container___27fJN","item":"Titles__item___2FKi3"};